import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';

import { APIComponent } from '../../../shared/api.component';
import { BaseLoopBackStorageService } from '../../../services/storage/loopback/base.service';
import { AccountLoopBackApiService } from '../../../services/api/loopback/custom/account.service';
import { DEFAULT_PASSWORD, VALIDATOR_PATERN } from '../../../shared/constants';

@Component({
  selector: 'drx-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AdminAccountComponent extends APIComponent {
  public title = 'Account';
  public path = 'admin/account';
  public minDateValue = new Date(Date.now());

  public constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected storageService: BaseLoopBackStorageService,
    protected apiService: AccountLoopBackApiService,
  ) {
    super(route, router, formBuilder, storageService, apiService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public createForm() {
    let currentDate = new Date();
    currentDate.setHours(0);
    currentDate.setMinutes(0 - currentDate.getTimezoneOffset());
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);
    let dateOfNextMonth = new Date(currentDate.getTime());
    dateOfNextMonth.setDate(dateOfNextMonth.getDate() + 30);
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: [DEFAULT_PASSWORD, Validators.required],
      ticket: this.formBuilder.group({
        domains: [[]],
        usedQueries: [0, [Validators.required, Validators.pattern('[0-9]*')]],
        totalQueries: [0, [Validators.required, Validators.pattern('[0-9]*')]],
        startDate: [currentDate, Validators.required],
        endDate: [dateOfNextMonth, Validators.required],
        autoReset: [false, Validators.required],
        overload: [false, Validators.required]
      })
    });
  }

  public bindData(data: any) {
    this.item = data;
    this.item['id'] = data['email'];
    if (data['ticket']) {
      this.item['ticket']['startDate'] = new Date(data['ticket']['startDate']);
      this.item['ticket']['endDate'] = new Date(data['ticket']['endDate']);
    }
  }

  public domainValidate(event: any) {
    if (!VALIDATOR_PATERN.DOMAIN.test(event.value)) {
      let domains = this.form.controls['ticket']['controls']['domains'].value;
      let index = domains.indexOf(event.value);
      if (index > -1) {
        domains.splice(index, 1);
      }
    }
  }

  public updateEndDate(event: any) {
    let newEndDate = new Date(event.getTime());
    newEndDate.setHours(0);
    newEndDate.setMinutes(0 - newEndDate.getTimezoneOffset());
    newEndDate.setSeconds(0);
    newEndDate.setMilliseconds(0);
    let newStartDate = new Date(newEndDate.getTime());
    this.item['startDate'] = newStartDate;
    this.form.controls['ticket']['controls']['startDate'].setValue(newStartDate);
    newEndDate.setDate(newEndDate.getDate() + 30);
    this.item['endDate'] = newEndDate;
    this.form.controls['ticket']['controls']['endDate'].setValue(newEndDate);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/account/account.component.ts